export default __webpack_public_path__ + "static/media/ico_pdf_grey.554e5046.svg";